/*
 * HYPEST · Nederlandse pagina = Nederlandse links, winkelwagen en afrekenen (2026-09-28)
 *
 * Sinds 28-09 ±08:36 geeft Shopify op de live winkel bij ongeveer 8 van de 10 Nederlandse pagina's
 * Engelse links mee (Shopify.routes.root = "/en/", routes.cart_add_url = "/en/cart/add",
 * menu/producten/footer naar /en/..., maatkeuze via data-url /en/products/...), terwijl de pagina
 * zelf Nederlands is (Shopify.locale "nl"). Gevolg: na 'In je winkelwagen', een maat kiezen of een
 * klik in het menu kwam een Nederlandse bezoeker op de Engelse winkel, winkelwagen en kassa.
 *
 * Dit script zet ALLEEN op een Nederlandse pagina (html lang="nl", pad niet /en) de /en/-links,
 * formulieren, data-url's en Shopify-routes terug naar de Nederlandse. Op Engelse pagina's
 * (dus ook na een eigen keuze 'English' via de taalknop) verandert er niets.
 * <link rel="alternate" hreflang> in de head wordt niet aangeraakt.
 *
 * In dezelfde Engelse opbouw geeft Shopify ook zijn eigen woorden voor sorteren en filteren in het
 * Engels ('Featured', 'Best selling', 'In stock'). Op een Nederlandse pagina (ook na het herladen van
 * de filters) zetten we die vaste woorden in de sorteer- en filterlijst terug naar de Nederlandse woorden die
 * Shopify normaal op deze pagina geeft.
 */
(function () {
  if (window.HypestNlRoutes) return;
  window.HypestNlRoutes = true;
  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang !== 'nl' || /^\/en(\/|$)/.test(location.pathname)) return;
  var EN = /^\/en(?=\/|$|\?|#)/;
  function strip(u) {
    if (typeof u !== 'string' || !EN.test(u)) return u;
    var r = u.replace(EN, '');
    return r === '' || r.charAt(0) !== '/' ? '/' + r : r;
  }
  var wasEn = !!(window.Shopify && window.Shopify.routes && EN.test(window.Shopify.routes.root || ''));
  var NL = {
    'Featured': 'Uitgelicht', 'Most relevant': 'Meest relevant', 'Best selling': 'Best verkopende',
    'Alphabetically, A-Z': 'Alfabetisch: A-Z', 'Alphabetically, Z-A': 'Alfabetisch: Z-A',
    'Price, low to high': 'Prijs: laag naar hoog', 'Price, high to low': 'Prijs: hoog naar laag',
    'Date, old to new': 'Datum: oud naar nieuw', 'Date, new to old': 'Datum: nieuw naar oud',
    'In stock': 'Op voorraad', 'Out of stock': 'Niet op voorraad'
  };
  var WORD = /^(\s*)(Featured|Most relevant|Best selling|Alphabetically, A-Z|Alphabetically, Z-A|Price, low to high|Price, high to low|Date, old to new|Date, new to old|In stock|Out of stock)(\s*(?:\(\d+\))?\s*)$/;
  var WSEL = '[class*="wt-options"], [custom-select-list], select[name="sort_by"], [class*="filter"], [class*="facet"]';
  function fixWords(scope) {

    try {
      (scope || document).querySelectorAll(WSEL).forEach(function (box) {
        var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null), n;
        while ((n = w.nextNode())) {
          var m = WORD.exec(n.nodeValue);
          if (m) n.nodeValue = m[1] + NL[m[2]] + m[3];
        }
        box.querySelectorAll('[data-label]').forEach(function (el) {
          var v = el.getAttribute('data-label'); if (NL[v]) el.setAttribute('data-label', NL[v]);
        });
      });
    } catch (e) {}
  }
  try {
    if (wasEn) window.Shopify.routes.root = '/';
    if (window.routes) Object.keys(window.routes).forEach(function (k) { window.routes[k] = strip(window.routes[k]); });
  } catch (e) {}
  var SEL = 'a[href^="/en"], form[action^="/en"], [data-url^="/en"], [data-cart-url^="/en"], [data-action^="/en"]';
  function fixEl(el) {
    ['href', 'action', 'data-url', 'data-cart-url', 'data-action'].forEach(function (a) {
      var v = el.getAttribute(a);
      if (v && EN.test(v)) el.setAttribute(a, strip(v));
    });
  }
  function fixDom(scope) {
    try { (scope || document).querySelectorAll(SEL).forEach(fixEl); } catch (e) {}
    fixWords(scope);
  }
  // vangnet: ook als er geklikt of verstuurd wordt voordat de DOM-fix liep
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href^="/en"]');
    if (a) fixEl(a);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && EN.test(f.getAttribute('action') || '')) fixEl(f);
  }, true);
  function boot() {
    fixDom();
    var t = null;
    try {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(fixDom, 30); })
        .observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  fixDom();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
